import globalCZ from '@translations/cz/global.json';



export const resources = {
	EN: {
		global: globalCZ,
	},
	CZ: {
		global: globalCZ,
	}
} as const;